import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { AthenaCredentials } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
export const fetchDataLakeConnectorRegions = async () => AthenaCredentials.listRegions();
const useDataLakeConnectorRegions = () => {
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: ["data-lake-connector-regions"],
    queryFn: () => defaultOnError(
      fetchDataLakeConnectorRegions(),
      i18n.t("notifications.fetch_connector_regions_failed", { ns: "enterprise_data_lake" }),
      i18n.t("notifications.fetch_connector_regions_failed_title", { ns: "enterprise_data_lake" })
    ),
    notifyOnChangeProps: ["data", "error"]
  });
  return {
    data,
    refetch,
    isLoading,
    error
  };
};
export default useDataLakeConnectorRegions;
